import React, { useEffect, useState } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import { useRecoilState } from 'recoil';
import { subAtom, outletAtom } from 'core/config/atoms';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import axios from 'axios';

import { API_URL } from 'services/models/AppConstent';

import ServiceFloor from 'services/serviceFloor';
import ServiceHostel from 'services/serviceHostel';
import ServiceOutlet from 'services/serviceOutlet';

import animBtnLoading from 'assets/anim/anim-btnLoading.json';
import animPage from 'assets/anim/anim-pageload.json';

const allowedExtensions = ["pdf", "png", "jpeg"];

export default function ComponentHostelBookingForm(props) {

    const [outlet] = useRecoilState(outletAtom);
    const [sub] = useRecoilState(subAtom);

    const [custFile, setCustFile] = useState(null);

    const [types, setTypes] = useState([]);
    const [floors, setFloors] = useState([]);

    const [selRooms, setSelRooms] = useState({});
    const [selBed, setSelBed] = useState({});
    const [taxSetting, setTax] = useState({});

    const [loading, setLoading] = useState(true);
    const [submit, setSubmit] = useState(false);

    const floorService = new ServiceFloor();
    const hostelService = new ServiceHostel();
    const outletService = new ServiceOutlet();

    const formVSchema = Yup.object().shape({
        roomType: Yup.string().required('This information is required'),
        roomFloor: Yup.string().required('This information is required'),
        checkIn: Yup.string().required('This information is required'),
        checkOut: Yup.string().required('This information is required'),
        roomIndex: Yup.number().required('This information is required'),
        roomBed: Yup.number().required('This information is required'),
        name: Yup.string().required('This information is required'),
        email: Yup.string().required('This information is required'),
        phone: Yup.string().required('This information is required'),
        total: Yup.number().required('This information is required'),
        extraCharges: Yup.number().required('This information is required'),
        discount: Yup.number().required('This information is required'),
        grand: Yup.number().required('This information is required'),
        ptype: Yup.string().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, resetForm, setErrors, setValues } = useFormik({
        initialValues: {
            roomType: '',
            roomFloor: '',
            checkIn: '',
            checkOut: '',
            roomIndex: -1,
            roomBed: -1,
            name: '',
            email: '',
            phone: '',
            clgName: '',
            docNum: '',
            docFile: {
                "fileurl": "https://placehold.co/320x200?text=No+Doc+Available"
            },
            total: 0,
            extraCharges: 0,
            discount: 0,
            tax: 0,
            grand: 0,
            ptype: '',
            pdate: '',
        },
        validationSchema: formVSchema,
        enableReinitialize: true,
        onSubmit: values => {
            let mediaFile = values.docFile;
            setSubmit(true);
            (async function () {
                if (custFile) {
                    var formData = new FormData();
                    formData.append("path", 'customer');
                    formData.append("doc", custFile);

                    var url = `${API_URL}file/uploadFile`;
                    var requestHeaders = {
                        'Content-type': 'multipart/form-data',
                        'Accept': '*/*',
                    };

                    const responseFile = await axios.post(url, formData, {
                        headers: requestHeaders,
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        },
                    });
                    mediaFile = responseFile.data.data;
                }
                var body = {
                    "outletid": outlet.outletid.id,
                    "outlet": outlet.outletid.outletid,
                    "roomType": values.roomType,
                    "roomFloor": values.roomFloor,
                    "roomIndex": values.roomIndex,
                    "roomBed": values.roomBed,
                    "checkIn": values.checkIn,
                    "checkOut": values.checkOut,
                    "name": values.name,
                    "phone": values.phone,
                    "email": values.email,
                    "extra": {
                        "clgName": values.clgName,
                        "docNum": values.docNum,
                        "docFile": mediaFile,
                    },
                    "ptype": values.ptype,
                    "pdate": values.ptype === "recurring" ? values.pdate : values.checkIn,
                    "total": values.total,
                    "extraCharge": values.extraCharges,
                    "discount": values.discount,
                    "tax": values.tax,
                    "finaltotal": values.grand,
                }
                hostelService.checkInBed(body, '').then((res) => {
                    if (res.status) {
                        resetForm();
                        setSelRooms({});
                        setSelBed({});
                        setCustFile(null);
                        props.onClose();
                        toast.success('New booking added.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    } else {
                        toast.error(res.msg, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                    setSubmit(false);
                });
            })();
        }
    });

    const handleFileChange = (e) => {
        var { value, name } = e.target;
        let isError = false;

        const inputFile = e.target.files[0];
        const fileExtension = inputFile?.type.split("/")[1];

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error('Only .pdf, .png, .jpg file format is allowed, please try again!', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            isError = true;
        }

        if (isError) {
            return;
        }

        setCustFile(inputFile);
    };

    const getFloors = () => {
        if (values.roomType === "") {
            return floors;
        }
        return floors.filter(floor =>
            floor.units?.some(unit => unit.roomTypeId === values.roomType)
        );
    }

    const getRooms = () => {
        if (values.roomFloor === "") {
            return [];
        }
        const tempList = floors.filter((floor) => floor._id === values.roomFloor);
        return tempList.length === 0 ? [] : tempList[0]["units"];
    }

    const getBeds = () => {
        if (Object.keys(selRooms).length === 0) {
            return [];
        }
        if (selRooms.subunit === undefined) {
            return [];
        }
        return selRooms.subunit.filter((subunit) => subunit.status === "none");
    }

    const calculateTotal = () => {
        let totalBasePrice = 0;
        let grandTotal = 0;

        if (Object.keys(selBed) !== 0) {
            totalBasePrice = values.total;

            grandTotal = parseFloat(totalBasePrice) + parseFloat(values.extraCharges);
            let taxAmount = 0;

            if (values.discount > 0) {
                grandTotal -= values.discount;
            }

            if (values.tax > 0) {
                if (Object.keys(taxSetting).length !== 0) {
                    switch (taxSetting.Room_TAX_TYPE) {
                        case "na":
                            taxAmount = 0;
                            break;
                        case "inclusive":
                            if (values.tax > 0) {
                                taxAmount =
                                    grandTotal -
                                    grandTotal / (1 + taxSetting.Room_Percentage / 100);
                            }
                            break;
                        case "exclusive":
                            taxAmount = grandTotal * (taxSetting.Room_Percentage / 100);
                            break;
                        case "overall":
                        default:
                            taxAmount = grandTotal * (values.tax / 100);
                            break;
                    }
                } else {
                    taxAmount = grandTotal * (values.tax / 100);
                }
                grandTotal += taxAmount;
            }
        }

        setValues({ ...values, grand: grandTotal, total: totalBasePrice });
    }

    const loadData = () => {
        setLoading(true);
        (async function () {
            var resA = await floorService.getAllRoomType({}, '');
            setTypes(resA.data);
            var resB = await floorService.getAllFloor({}, '');
            setFloors(resB.data);
            if (sub.features.isTax) {
                var res = await outletService.getOutletById({ 'outletid': outlet.outletid.outletid });
                const taxSet = res.data.tax;
                setTax(taxSet);
                setValues({ ...values, tax: taxSet.Room_Percentage });
            }
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (Object.keys(selBed) !== 0) {
            calculateTotal();
        }
    }, [selBed, values.total, values.tax, values.extraCharges, values.discount]);

    return (
        <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className='bg-white w-[70%] min-h-screen absolute right-0 p-[20px]'>
                <ScrollArea>
                    <div className='px-2'>
                        <div className='flex items-center justify-between text-2xl'>
                            <h1 className='font-sans font-medium text-gray-900 uppercase'>Hostel Booking Form</h1>
                            <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => {
                                resetForm();
                                setSelRooms({});
                                setSelBed({});
                                setCustFile(null);
                                props.onClose();
                            }}>
                                <span><i className="las la-times text-xl cursor-pointer"></i></span>
                            </div>
                        </div>
                        <hr className='my-2' />
                        {
                            loading && <div className='flex items-center justify-center w-full h-full'>
                                <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                            </div>
                        }
                        {
                            !loading && <form className='mt-4 grid grid-cols-12 gap-4' onSubmit={handleSubmit} onReset={handleReset} noValidate="" autoComplete='off'>
                                <div className="col-span-12 font-medium">
                                    <p>Booking information</p>
                                    <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Select Room Types<sup className="text-red-600">*</sup></label>
                                    <select type="text" id="roomType" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" onChange={handleChange}>
                                        <option value="">Room type</option>
                                        {
                                            types.map((type) => {
                                                return <option value={type._id} selected={values.roomType === type._id}>{type.name}</option>
                                            })
                                        }
                                    </select>
                                    {(errors.roomType && touched.roomType) && <p className='text-xs text-red-400 mt-1'>{errors.roomType}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Select Floor<sup className="text-red-600">*</sup></label>
                                    <select type="text" id="roomFloor" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" onChange={handleChange}>
                                        <option value="">Select Floor</option>
                                        {
                                            getFloors().map((floor) => {
                                                return <option value={floor._id} selected={values.roomFloor === floor._id}>{floor.title}</option>
                                            })
                                        }
                                    </select>
                                    {(errors.roomFloor && touched.roomFloor) && <p className='text-xs text-red-400 mt-1'>{errors.roomFloor}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Check-In Date<sup className="text-red-600">*</sup></label>
                                    <input type="date" id="checkIn" value={values.checkIn} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.checkIn && touched.checkIn) && <p className='text-xs text-red-400 mt-1'>{errors.checkIn}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Check-Out Date<sup className="text-red-600">*</sup></label>
                                    <input type="date" id="checkOut" value={values.checkOut} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.checkOut && touched.checkOut) && <p className='text-xs text-red-400 mt-1'>{errors.checkOut}</p>}
                                </div>

                                <div className="col-span-12 space-y-2">
                                    <div className='w-full'>
                                        <label className="block mb-1 text-sm font-medium text-gray-900">Select Room</label>
                                        <div className='w-full grid grid-cols-6 gap-2'>
                                            {
                                                Object.keys(selRooms).length !== 0 && <div className="p-2 rounded col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md bg-green-600" onClick={() => {
                                                    setValues({ ...values, roomIndex: -1 });
                                                    setSelRooms({});
                                                }}>
                                                    <div className='flex justify-between items-center px-1'>
                                                        <div>
                                                            <p className='text-xl font-medium font-serif'>{selRooms.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                Object.keys(selRooms).length === 0 && getRooms().map((unit, index) => {
                                                    return <div className="p-2 rounded col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md bg-white" key={index} onClick={() => {
                                                        const ft = floors.filter((floor) => floor._id === values.roomFloor)[0];
                                                        let roomIndex = ft.units.findIndex((a) => a.title === unit.title);
                                                        setValues({ ...values, roomIndex: roomIndex });
                                                        setSelRooms(unit);
                                                    }}>
                                                        <div className='flex justify-between items-center px-1'>
                                                            <div>
                                                                <p className='text-xl font-medium font-serif'>{unit.title}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                            }
                                            {
                                                getRooms().length === 0 && <div className='w-full text-center border rounded py-2 text-sm'>
                                                    No rooms avaliable
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-12 space-y-2">
                                    <div className='w-full'>
                                        <label className="block mb-1 text-sm font-medium text-gray-900">Select Bed</label>
                                        <div className='w-full grid grid-cols-6 gap-2'>
                                            {
                                                Object.keys(selBed).length !== 0 && <div className="p-2 rounded col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md bg-green-600" onClick={() => {
                                                    setValues({ ...values, roomBed: -1 });
                                                    setSelBed({});
                                                }}>
                                                    <div className='flex justify-between items-center px-1'>
                                                        <div>
                                                            <p className='text-xl font-medium font-serif'>{selBed.title}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                Object.keys(selBed).length === 0 && getBeds().map((bed, index) => {
                                                    return <div className="p-2 rounded col-span-1 border border-dashed border-gray-400 cursor-pointer hover:shadow-md bg-white" key={index} onClick={() => {
                                                        const ft = floors.filter((floor) => floor._id === values.roomFloor)[0];
                                                        let bedIndex = ft.units[values.roomIndex].subunit.findIndex((a) => a.title === bed.title);
                                                        setValues({ ...values, roomBed: bedIndex, total: bed.price });
                                                        setSelBed(bed);
                                                    }}>
                                                        <div className='flex justify-between items-center px-1'>
                                                            <div>
                                                                <p className='text-xl font-medium font-serif'>{bed.title}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                            }
                                            {
                                                getBeds().length === 0 && <div className='w-full text-center border rounded py-2 text-sm'>
                                                    No beds avaliable
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-12 font-medium">
                                    <p>Customer information</p>
                                    <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Customer Name<sup className="text-red-600">*</sup></label>
                                    <input type="text" id="name" value={values.name} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Jhon Deo" onChange={handleChange} />
                                    {(errors.name && touched.name) && <p className='text-xs text-red-400 mt-1'>{errors.name}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Customer Email Address<sup className="text-red-600">*</sup></label>
                                    <input type="email" id="email" value={values.email} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. jhon.deo@gmail.com" onChange={handleChange} />
                                    {(errors.email && touched.email) && <p className='text-xs text-red-400 mt-1'>{errors.email}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Customer Phone Number<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="phone" value={values.phone} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.phone && touched.phone) && <p className='text-xs text-red-400 mt-1'>{errors.phone}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Collage Name<sup className="text-gray-700 font-mono">(Optional)</sup></label>
                                    <input type="text" id="clgName" value={values.clgName} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Jhon Deo" onChange={handleChange} />
                                    {(errors.clgName && touched.clgName) && <p className='text-xs text-red-400 mt-1'>{errors.clgName}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Document Number<sup className="text-gray-700 font-mono">(Optional)</sup></label>
                                    <input type="text" id="docNum" value={values.docNum} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Jhon Deo" onChange={handleChange} />
                                    {(errors.docNum && touched.docNum) && <p className='text-xs text-red-400 mt-1'>{errors.docNum}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Customer Document<sup className="text-gray-700 font-mono">(Optional)</sup></label>
                                    <input type="file" autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. Select file" onChange={handleFileChange} />
                                </div>

                                <div className="col-span-12 font-medium">
                                    <p>Payment information</p>
                                    <div className='w-full h-[1px] bg-gray-400 mt-1'></div>
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Select Payment Type<sup className="text-red-600">*</sup></label>
                                    <select type="text" id="ptype" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" onChange={handleChange}>
                                        <option value="">Payment Type</option>
                                        <option value="single" selected={values.ptype === "single"}>One Time Payment</option>
                                        <option value="recurring" selected={values.ptype === "recurring"}>Monthly Payment</option>
                                    </select>
                                    {(errors.ptype && touched.ptype) && <p className='text-xs text-red-400 mt-1'>{errors.ptype}</p>}
                                </div>

                                {
                                    values.ptype === "recurring" && <>
                                        <div className="col-span-4">
                                            <label className="block mb-2 text-sm font-medium text-gray-600">Payment Date<sup className="text-red-600">*</sup></label>
                                            <input type="date" id="pdate" value={values.pdate} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                            {(errors.pdate && touched.pdate) && <p className='text-xs text-red-400 mt-1'>{errors.pdate}</p>}
                                        </div>
                                    </>
                                }

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Booking Total (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="total" value={values.total} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.total && touched.total) && <p className='text-xs text-red-400 mt-1'>{errors.total}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Extra Charges (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="extraCharges" value={values.extraCharges} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.extraCharges && touched.extraCharges) && <p className='text-xs text-red-400 mt-1'>{errors.extraCharges}</p>}
                                </div>

                                {
                                    sub.features.isTax && <div className="col-span-4">
                                        <label className="block mb-2 text-sm font-medium text-gray-600">Tax (%)<sup className="text-red-600">*</sup></label>
                                        <input type="number" id="tax" value={values.tax} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                        {(errors.tax && touched.tax) && <p className='text-xs text-red-400 mt-1'>{errors.tax}</p>}
                                    </div>
                                }

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Discount (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="discount" value={values.discount} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. xxxxxxxxxx" onChange={handleChange} />
                                    {(errors.discount && touched.discount) && <p className='text-xs text-red-400 mt-1'>{errors.discount}</p>}
                                </div>

                                <div className="col-span-4">
                                    <label className="block mb-2 text-sm font-medium text-gray-600">Grand Total (₹)<sup className="text-red-600">*</sup></label>
                                    <input type="number" id="grand" value={values.grand} autoComplete='off' readOnly className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="i.e. x" onChange={handleChange} />
                                    {(errors.grand && touched.grand) && <p className='text-xs text-red-400 mt-1'>{errors.grand}</p>}
                                </div>

                                <div className='col-span-12 my-6'>
                                    <div className='flex items-end'>
                                        <button type="submit" className="text-white bg-prime hover:bg-primeLight focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center" disabled={submit}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && "Add Booking"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                </ScrollArea >
            </div >
        </div>
    )
}
